import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { MaquinasequipControleForm, MaquinasequipControleSchema } from "../../../schemas/MaquinasEquip_controle/MaquinasEquip_controle";
import { ControleCentroCustoLista } from "../../../../domain/models/controle_centro_custo_lista";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";

/**
 * ModalCreateMaquinasequipControle
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedControleCentroCusto: ControleCentroCustoLista | null;
  centroCustoDropdown: CentroCustoDropDown[];
  onClose: () => void;
  onSubmit: (form: MaquinasequipControleForm) => void;
};

export const ModalCreateMaquinasequipControle = ({
  open,
  saving,
  loading,
  selectedControleCentroCusto,
  centroCustoDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<MaquinasequipControleForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(MaquinasequipControleSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedControleCentroCusto) {
        hookForm.setValue("idCentroCusto", selectedControleCentroCusto.idCentroCusto);
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectedControleCentroCusto,
    hookForm
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Controle Centro de Custo"
      onSubmit={hookForm.handleSubmit(onSubmit)}
      onClose={onClose}>
      <div className="w-full flex flex-col gap-2 my-2">
        <DefaultFormAutocomplete
          name='idCentroCusto'
          label='Centro de Custo'
          options={centroCustoDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
};
